// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-wrapper{min-height:100px;min-width:100px;position:relative}.loader-wrapper .loader{bottom:0;left:0;position:absolute;right:0;top:0;z-index:9999}.fullscreen{position:unset}", ""]);
// Exports
module.exports = exports;
